module.exports = __webpack_public_path__ + "img/ok_green.54007818.svg";